import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { CompanySize } from "../../pages/ManageCompanySize/schema/company-size";

import { companySizeApi } from "./company-size.api";

const initialState: CompanySize[] = [];

export const companySizeSlice = createSlice({
	name: "company-size",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			companySizeApi.endpoints.getCompanySizes.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
		builder.addMatcher(
			companySizeApi.endpoints.createCompanySize.matchFulfilled,
			(state, { payload }) => {
				if (payload?.id) {
					return [...state, payload];
				}
			}
		);
		builder.addMatcher(
			companySizeApi.endpoints.updateCompanySize.matchFulfilled,
			(state, { payload }) => {
				const index = state.findIndex((i) => i.id === payload.id);

				if (index !== -1) {
					state[index] = payload;
				}

				return state;
			}
		);
		builder.addMatcher(
			companySizeApi.endpoints.deleteCompanySize.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
	},
});

export const companySizeReducer = companySizeSlice.reducer;
export const companySizeSelector = (state: RootState) => state[companySizeSlice.name];
